import { cn } from '@/lib/utils'

const variants = {
  default: 'bg-surface-raised text-text hover:bg-[#2a2a2a] border border-border',
  primary: 'bg-accent text-black hover:opacity-90 font-medium',
  ghost: 'text-text-muted hover:text-text hover:bg-surface-raised',
  danger: 'bg-red-500/10 text-red-400 hover:bg-red-500/20 border border-red-500/20',
}

const sizes = {
  sm: 'h-7 px-2.5 text-xs rounded-md gap-1.5',
  md: 'h-8 px-3 text-sm rounded-lg gap-2',
  lg: 'h-9 px-4 text-sm rounded-lg gap-2',
  xl: 'h-11 px-5 text-sm rounded-xl gap-2.5',
  '2xl': 'h-12 px-6 text-base rounded-xl gap-3',
}

export function Button({ variant = 'default', size = 'md', className, children, ...props }) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center font-medium transition-all duration-150 whitespace-nowrap',
        'active:scale-[0.97] select-none cursor-pointer disabled:opacity-40 disabled:pointer-events-none',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
